var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"router-container"},[_c('nav',{directives:[{name:"show",rawName:"v-show",value:(_vm.showNav),expression:"showNav"}],staticClass:"router-nav"},_vm._l((_vm.routeList),function(ref){
var title = ref.title;
var to = ref.to;
return _c('router-link',{key:to,attrs:{"to":to}},[_c('span',[_vm._v(_vm._s(title))])])}),1),_c('section',{staticClass:"router-content"},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }